import { useMeetingData } from '@/contexts/MeetingDataContext'

type LocalParticipantInitials = {
  initials: string
  firstName: string
}

/**
 * Hook to get the current user's initials and first name for display in the meeting
 * Calculates initials from the user's first name (max 2 characters)
 * Returns both initials and the full first name
 * Fallback: "V" for initials, "Vous" for first name
 */
export const useLocalParticipantInitials = (): LocalParticipantInitials => {
  const { currentUserName } = useMeetingData()

  const firstName = currentUserName ?? 'Vous'

  // Calculate initials: split by spaces, take first letter of each word, max 2 chars
  const initials = firstName
    .split(' ')
    .map((n: string) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)

  return {
    initials: initials || 'V', // Fallback to 'V' if empty
    firstName
  }
}
